module.exports = __webpack_public_path__ + "static/media/rocket.a3411f2d.svg";